import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

export type ListProps = {
	id: string;
	name: string;
};

export const useSubordinatedListsData = () => {
	const [lists, subordinateLists] = useSelector<
		RootState,
		[Array<ListProps>, Array<ListProps>]
	>(
		state => [
			state.dashboard.getIn(['lists', 'data']).toJS(),
			state.dashboard.getIn(['subordinateLists', 'data'])?.toJS()
		],
		shallowEqual
	);

	return { lists, subordinateLists };
};
